import { AbstractPlugin } from '../plugin';

export class CameraVFXItemLoader extends AbstractPlugin {
}
